import PopoverBody from "@molecules/Popover/PopoverBody/PopoverBody"

export default PopoverBody
